import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TYPE_DISABLE } from '../../common/sync-component/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import Tab from '../../common/tab';
import {
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../helpers/EventEmitter';
import { changeCode } from './reducer';
import TabContent from './tab-content/TabContent';
import Const from './Const';
import './index.scss';
import ScrollComponent from './../../common/ScrollComponent';
import PreRender from './../../common/PreRender';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';
import { Provider } from './../../common/ComponentIdContext';
import { ComponentNameProvider } from './../../common/ComponentNameContext';

const mapTab = {
  overview: 1,
  orderStatistic: 2,
  foreign: 3,
  proprietary: 4,
};

class PriceData extends Component {
  constructor(props) {
    super(props);
    const tabFromQuery = mapTab[getQueryParams('tab')];
    this.state = {
      currentTab:
        tabFromQuery ||
        props.tab ||
        currentState.get(
          ConstCommon.listComponent.PriceData,
          'currentTab',
          props.id,
        ) ||
        Const.tabs.overview,
    };
    removeDragCode(this.props.glContainer);
  }

  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, id } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      syncType !== data.syncType ||
      data.search.isDerivatives
    ) {
      return;
    }
    changeCode(data.search, id);
  };

  changeTab = currentTab => {
    currentState.add(
      ConstCommon.listComponent.PriceData,
      'currentTab',
      currentTab,
      this.props.id,
    );
    this.setState({ currentTab });
  };

  render() {
    const { currentTab } = this.state;

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.PriceData}>
          <Provider value={this.props.id}>
            <ScrollComponent>
              <div className="top-nav pt-8 px-20 h-100 d-flex flex-column">
                <Tab
                  locks={[Const.tabs.properietary]}
                  currentTab={this.state.currentTab}
                  listTab="priceData.lstTab"
                  changeTab={this.changeTab}
                />
                <div className="tab-content flex-fill d-flex flex-column h-auto">
                  <TabContent currentTab={currentTab} />
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id }) => ({
  syncType: syncComponentSelector(
    state,
    ConstCommon.listComponent.PriceData,
    id,
  ),
});

const mapDispatchToProps = {
  changeCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withSyncDragCode,
)(PriceData);
